import { createAction } from '@reduxjs/toolkit';

export const openQueuePriorityModal = createAction('queuePriorityModal/open');
export const closeQueuePriorityModal = createAction('queuePriorityModal/close');
